import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { nultiSelectStyles } from '../../../../../../../../utils/styles';
import CashbackPresenter, {
  QUARANTINED_REASONS,
} from '../../../../../../../../presenters/CashbackPresenter';

const QuarantinedReasonsSelect = (props) => {
  const { values, onChange } = props;

  const options = Object.values(QUARANTINED_REASONS).map((reason) => {
    return {
      key: reason,
      label: CashbackPresenter.quarantinedReasonReadable({
        quarantinedReason: reason,
      }),
      value: reason,
    };
  });

  const defaultReasonsOptions = options.filter((option) =>
    values.quarantinedReasonIn.includes(option.value)
  );

  const handleChange = (newValues) =>
    onChange('quarantinedReasonEq', newValues);

  return (
    <Select
      defaultValue={defaultReasonsOptions}
      isMulti
      id="quarantinedReasonEq"
      options={options}
      className="basic-multi-select input-underlined"
      classNamePrefix="filter"
      onChange={handleChange}
      styles={nultiSelectStyles}
      required
    />
  );
};

export default QuarantinedReasonsSelect;

QuarantinedReasonsSelect.propTypes = {
  values: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
};
